module.exports = __webpack_public_path__ + "img/tablet-screen-button.d586ebee.svg";